var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg075Search(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 10C2 14.4183 5.58172 18 10 18C11.7767 18.0022 13.5025 17.407 14.9 16.31L19.29 20.71C19.4778 20.8993 19.7334 21.0058 20 21.0058C20.2666 21.0058 20.5222 20.8993 20.71 20.71C20.8993 20.5222 21.0058 20.2666 21.0058 20C21.0058 19.7334 20.8993 19.4778 20.71 19.29L16.31 14.9C17.407 13.5025 18.0022 11.7767 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10ZM10 4C13.3137 4 16 6.68629 16 10C16 13.3137 13.3137 16 10 16C6.68629 16 4 13.3137 4 10C4 6.68629 6.68629 4 10 4Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg075Search);
export default __webpack_public_path__ + "static/media/075-search.ca3e100b1c0dd7220188fe256505fb8a.svg";
export { ForwardRef as ReactComponent };